import { SVGProps, Ref, forwardRef } from 'react';

export const ATSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M0 6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v3H0z" fill="#ED2939" />
        <path d="M0 15h24v3a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z" fill="#ED2939" />
        <path d="M0 9h24v6H0z" fill="#EEEEEE" />
    </svg>
));
ATSize24Glyph.displayName = 'ATSize24Glyph';
